import { render } from "./ContactView.vue?vue&type=template&id=07a36e77&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=07a36e77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a36e77"]])

export default __exports__